import React from 'react'

import { OptionsMenu } from '../data-card/data-card-parts'

export default ({
  servicing,
  transferable,
  markServicingAsLowPriority,
  markServicingAsHighPriority,
  deleteServicing,
  toggleRequireImages,
  transferServicing,
  buttonClasses
}) => {
  let options = [
    {
    name: (servicing.highPriority === true) ? 'Mark as Low Priority' : 'Mark as High Priority',
    action: (servicing.highPriority === true) ? markServicingAsLowPriority : markServicingAsHighPriority
  },
    {
    name: (servicing.requireImages === true) ? 'Remove Images Requirement' : 'Require Images',
    action: toggleRequireImages
  },
  {
    name: 'Delete',
    action: deleteServicing
  }
]

if (transferable) {
  options.unshift({
    name: 'Transfer',
    action: transferServicing
  })
}

  return (
  <OptionsMenu buttonClasses={buttonClasses} optionItems={options} />
)}



// WEBPACK FOOTER //
// ./src/components/areas/area-options.js